.overflowYHidden {
  overflow-y: hidden !important;
}
